import { Button, Grid, TextareaAutosize, Typography } from "@mui/material";
import GenericModal from "../GenericModal";
import { Vocabulary } from "../../Utils/Vocabulary";
import SaveIcon from "@mui/icons-material/Save";
import genericStyles from "../../Styles/genericStyles.module.css";

interface DrivingRulesSettingsProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  data: { drivingRules: string; } | null;
  setData: (data: { drivingRules: string; }) => void;
}

const drivingRulesOptions = (onClose: any, handleSubmit: any) => {
  return (<div className={genericStyles.modalActions}>
    <Button color="error" variant="outlined" fullWidth onClick={onClose}>
      {Vocabulary.cancel}
    </Button>
    <Button
      fullWidth
      onClick={handleSubmit}
      variant="contained"
      startIcon={<SaveIcon />}
    >
      {Vocabulary.save}
    </Button>
  </div>);
};

export default function DrivingRulesSettings(props: DrivingRulesSettingsProps) {



  return (
    <GenericModal
      open={props.isOpen}
      onClose={props.onClose}
      title={Vocabulary.drivingRules}
      actions={drivingRulesOptions(props.onClose, props.onSubmit)}
    >
      {/* Driving Rules Section */}
      <Grid container spacing={3}  >
        <Grid item xs={12}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            {Vocabulary.drivingRulesDescription}
          </Typography>
        </Grid>
        <Grid item xs={12}>

          <TextareaAutosize
            aria-label="driving rules"
            placeholder={Vocabulary.addDrivingRules}
            value={props.data?.drivingRules || ""}
            style={{
              width: '100%',
              minHeight: 200,
              fontFamily: 'inherit',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              resize: 'vertical'
            }}
            onChange={(e) => props.setData({
              drivingRules: e.target.value,
            })}
          />
        </Grid>
      </Grid>
    </GenericModal >
  );
}
